import React from 'react';
import clsx from 'clsx';
import { Icon, Message } from 'semantic-ui-react';
import { FormattedMessage } from 'react-intl';
import { hasMinimumLength } from '@/utils/resultsHelper';
import FormattedHTMLMessage from '../FormattedHTMLMessage';
import CopyIcon from '../CopyIcon';

const DialogHeaderMessage = ({
  className,
  copyText,
  error,
  icon = 'info',
  loading,
  message,
  values,
  warning,
}) => (
  <Message
    className={clsx('modal-message aridhia-dialog-header-message', className)}
    warning={warning}
    error={error}
  >
    {loading && (<Icon name="circle notched" className="primary" loading />)}
    {!loading && !hasMinimumLength(copyText) && (<Icon name={icon} className="primary" />)}
    {!loading && hasMinimumLength(copyText) && (<CopyIcon text={copyText} icon={icon} />)}
    {loading && (<FormattedMessage id="actions.loading" values={values} />)}
    {!loading && (<FormattedHTMLMessage id={message} values={values} />)}
  </Message>
);

export default DialogHeaderMessage;
